__webpack_require__.p = "https://ikea.marat.qd.je/si/sl/customer-service/support/";